import React, { useEffect, useRef, useState } from 'react';
import {Button, Col, Form, FormGroup, Input, Label, Row, Spinner} from "reactstrap";
import { useForm } from "react-hook-form";

import { error, infoMsg, SAVE, saveMsg, success} from "../i18n/i18n";
import {ButtonCancel} from "../buttons/buttonsActions";
import { showToastCustom } from "../toast/customToast";
import {xwitchLogService} from "../../jwt/_services/bi/xwitchLogService";
import * as Yup from "yup";

export const ConfirmDepurate = ({  onClose }) => {

    const [saving, setSaving] = useState(false)

    const validationSchema = Yup.object().shape({
        from: Yup.string().required('Campo requerido'),
        to: Yup.string().required('Campo requerido')
    });

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
    const currentDate = today.toISOString().split('T')[0];

    // default firstDay and lastDay of month
    const {register, handleSubmit, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            from: firstDayOfMonth,
            to: currentDate
        }
    });

    const isMounted = useRef(true)

    //Actualizar la referencia
    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    },[])

    const onSubmit = (data, _) => {
        const dataRequest = {
            ...data
        }

        // console.log(dataRequest);
        // return;

        setSaving(true)
        xwitchLogService.depurate(dataRequest)
            .then(result => {
                if(!result?.status)
                    return

                showToastCustom(success, saveMsg);
                onClose();
            })
            .catch( _ => {
                    showToastCustom(error, infoMsg, true);
                }
            )
            .finally(() => {
                if(isMounted.current) {
                    setSaving(false)
                }
                onClose()
            });
    }

    return (
        <div className='custom-ui'>
            <h1>{ "Unificar registros" }</h1>

            <br/>
            <div style={{textAlign:'left'}}>
                <Form onSubmit={ handleSubmit(onSubmit) }>
                    <Row>
                        <Col md={"2"}><h4 style={ {textAlign:'center'} }>{  }</h4></Col>
                        <Col md={"8"}><h4 style={ {textAlign:'center'} }>{ "Unifica los registros que tienen mismo TransactionId segun el rango de fechas seleccionado" }</h4></Col>
                        <Col md={"2"}><h4 style={ {textAlign:'center'} }>{  }</h4></Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Desde</Label>
                                <Input type="date"
                                       name="from"
                                       innerRef={register}
                                       className={(errors.from ? ' is-invalid' : '')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label>Hasta</Label>
                                <Input type="date"
                                       name="to"
                                       innerRef={register}
                                       className={(errors.to ? ' is-invalid' : '')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <br/>
                    <br/>
                    <div style={{textAlign:'center'}}>
                        <ButtonCancel onClick={onClose}/>
                        &nbsp;&nbsp;
                        <Button
                            type={"submit"}
                            className="btn-add ml-auto ml-2"
                            disabled={ saving }
                        >
                            { SAVE }
                        </Button>
                        {
                            saving && <>
                                <br/><br/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                                <Spinner animation="border" size='sm' type='grow'/>
                            </>
                        }
                    </div>
                </Form>
            </div>
        </div>
    );
}